import { DevelopmentTool } from '@wix/ambassador-devcenter-apps-v1-app-template/types';

export const GITHUB_LINK_DEV_TOOLS_SET = new Set([
  DevelopmentTool.CLI,
  DevelopmentTool.DEV_CENTER,
]);
